import BaseColumnDefinitions from '../baseColumnDefinitions';
import InternationalColumns from '../internationalColumns';

const GOALS_ASSISTS_COL = [
    BaseColumnDefinitions.GOALS_COL,
    BaseColumnDefinitions.ASSISTS_COL,
    BaseColumnDefinitions.POINTS_COL,
];

const POWER_PLAY_COL = [
    BaseColumnDefinitions.POWER_PLAY_GOALS_COL,
    BaseColumnDefinitions.POWER_PLAY_ASSISTS_COL,
    BaseColumnDefinitions.POWER_PLAY_POINTS_COL,
];

const CAREER_COL = [
    BaseColumnDefinitions.INDEX_COL,
    InternationalColumns.PLAYER_NAME,
    InternationalColumns.POSITION,
    InternationalColumns.TEAM_NAMES,
    BaseColumnDefinitions.GAMES_PLAYED_COL,
];

const TOURNAMENT_COL = [
    BaseColumnDefinitions.INDEX_COL,
    InternationalColumns.PLAYER_NAME,
    InternationalColumns.POSITION,
    InternationalColumns.TEAM_NAME,
    InternationalColumns.TOURNAMENT_NAME,
    BaseColumnDefinitions.GAMES_PLAYED_COL,
];

const GAME_COL = [
    BaseColumnDefinitions.INDEX_COL,
    InternationalColumns.PLAYER_NAME,
    InternationalColumns.POSITION,
    InternationalColumns.TEAM_NAME,
    InternationalColumns.TOURNAMENT_NAME,
    InternationalColumns.SERIES_TITLE,
    InternationalColumns.GAME_INFO,
];

const SHOOTER_GAME_COL = [
    BaseColumnDefinitions.INDEX_COL,
    InternationalColumns.SHOOTER,
    InternationalColumns.POSITION,
    InternationalColumns.TEAM_NAME,
    InternationalColumns.TOURNAMENT_NAME,
    InternationalColumns.SERIES_TITLE,
    InternationalColumns.GAME_INFO,
];

const GOALS_ASSISTS_CAREER_COL = [...CAREER_COL, ...GOALS_ASSISTS_COL];
const GOALS_ASSISTS_TOURNAMENT_COL = [...TOURNAMENT_COL, ...GOALS_ASSISTS_COL];
const GOALS_ASSISTS_GAME_COL = [...GAME_COL, ...GOALS_ASSISTS_COL];
const GOALS_ASSISTS_PERIOD_COL = [...GAME_COL, InternationalColumns.PERIOD_COL, ...GOALS_ASSISTS_COL];

const POWER_PLAY_CAREER_COL = [...CAREER_COL, ...POWER_PLAY_COL];
const POWER_PLAY_TOURNAMENT_COL = [...TOURNAMENT_COL, ...POWER_PLAY_COL];
const POWER_PLAY_GAME_COL = [...GAME_COL, ...POWER_PLAY_COL];

export const skaterInternationalColumns = {
    'international-skater-most-championships-career': [
        BaseColumnDefinitions.INDEX_COL,
        InternationalColumns.PLAYER_NAME,
        InternationalColumns.POSITION,
        InternationalColumns.TEAM_NAMES,
        InternationalColumns.CHAMPIONSHIPS,
        InternationalColumns.YEARS_WON,
    ],
    'international-skater-most-tournaments-played-career': [
        BaseColumnDefinitions.INDEX_COL,
        InternationalColumns.PLAYER_NAME,
        InternationalColumns.POSITION,
        InternationalColumns.TEAM_NAMES,
        InternationalColumns.TOURNAMENTS_PLAYED,
        BaseColumnDefinitions.GAMES_PLAYED_COL,
        InternationalColumns.CHAMPIONSHIPS,
    ],
    'international-skater-most-games-played-career': [
        BaseColumnDefinitions.INDEX_COL,
        InternationalColumns.PLAYER_NAME,
        InternationalColumns.POSITION,
        InternationalColumns.TEAM_NAMES,
        InternationalColumns.TOURNAMENTS_PLAYED,
        BaseColumnDefinitions.GAMES_PLAYED_COL,
        InternationalColumns.CHAMPIONSHIPS,
    ],
    'international-skater-most-goals-career': GOALS_ASSISTS_CAREER_COL,
    'international-skater-most-goals-tournament': GOALS_ASSISTS_TOURNAMENT_COL,
    'international-skater-most-goals-game': GOALS_ASSISTS_GAME_COL,
    'international-skater-most-goals-period': GOALS_ASSISTS_PERIOD_COL,
    'international-skater-most-game-winning-goals-career': [
        ...GOALS_ASSISTS_CAREER_COL,
        InternationalColumns.GAME_WINNING_GOALS,
    ],
    'international-skater-most-assists-career': GOALS_ASSISTS_CAREER_COL,
    'international-skater-most-assists-tournament': GOALS_ASSISTS_TOURNAMENT_COL,
    'international-skater-most-assists-game': GOALS_ASSISTS_GAME_COL,
    'international-skater-most-assists-period': GOALS_ASSISTS_PERIOD_COL,
    'international-skater-most-points-career': GOALS_ASSISTS_CAREER_COL,
    'international-skater-most-points-tournament': GOALS_ASSISTS_TOURNAMENT_COL,
    'international-skater-most-points-game': GOALS_ASSISTS_GAME_COL,
    'international-skater-most-points-period': GOALS_ASSISTS_PERIOD_COL,
    'international-skater-most-power-play-goals-career': POWER_PLAY_CAREER_COL,
    'international-skater-most-power-play-assists-career': POWER_PLAY_CAREER_COL,
    'international-skater-most-power-play-points-career': POWER_PLAY_CAREER_COL,
    'international-skater-most-power-play-goals-tournament': POWER_PLAY_TOURNAMENT_COL,
    'international-skater-most-power-play-goals-game': POWER_PLAY_GAME_COL,
    'international-skater-all-time-shorthanded-goals': [
        InternationalColumns.SHOOTER,
        InternationalColumns.POSITION,
        InternationalColumns.TEAM_NAME,
        InternationalColumns.TOURNAMENT_NAME,
        InternationalColumns.SERIES_TITLE,
        InternationalColumns.GAME_INFO,
        InternationalColumns.PERIOD_COL,
        InternationalColumns.TIME_IN_PERIOD,
    ],
    'international-skater-all-time-penalty-shots': [
        InternationalColumns.SHOOTER,
        InternationalColumns.SHOOTER_TEAM,
        InternationalColumns.GOALTENDER,
        InternationalColumns.GOALTENDER_TEAM,
        InternationalColumns.TOURNAMENT_NAME,
        InternationalColumns.SERIES_TITLE,
        InternationalColumns.GAME_INFO_PENALTY_SHOT,
        InternationalColumns.SCORED,
        {
            ...InternationalColumns.PERIOD_COL,
            accessor: 'shotPeriod',
        },
        InternationalColumns.SHOT_TIME,
    ],
    'international-skater-fastest-goals-from-start-of-game': [
        ...SHOOTER_GAME_COL,
        InternationalColumns.SECONDS_ELAPSED_IN_GAME,
    ],
    'international-skater-fastest-goals-from-start-of-any-period': [
        ...SHOOTER_GAME_COL,
        InternationalColumns.PERIOD_COL,
        InternationalColumns.SECONDS_ELAPSED_IN_PERIOD,
    ],
    'international-skater-fastest-two-goals-from-start-of-game': [
        ...SHOOTER_GAME_COL,
        InternationalColumns.FASTEST_TWO_GOALS_TIME_FROM_START_PERIOD,
    ],
    'international-skater-fastest-two-goals-any-time-of-game': [
        ...SHOOTER_GAME_COL,
        InternationalColumns.GOAL1(),
        InternationalColumns.GOAL2(),
        InternationalColumns.TIME_BETWEEN_GOALS,
    ],
    'international-skater-fastest-three-goals-any-time-of-game': [
        ...SHOOTER_GAME_COL,
        InternationalColumns.GOAL1(),
        InternationalColumns.GOAL2(),
        InternationalColumns.GOAL3(),
        InternationalColumns.TIME_BETWEEN_GOALS,
    ],
};
